/*
GPS DataViz

Copyright © 2021 GPSDataViz

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/

import { Table } from "antd";

const columns = [
  {
    title: "Drill",
    dataIndex: "drill_name",
    key: "drill_name",
    width: "70%",
    render: (drill_name) => <p>{drill_name}</p>,
  },
  {
    title: "Training AVG",
    dataIndex: "training_avg",
    key: "training_avg",
    width: "30%",
    sorter: {
      compare: (a, b) => a.training_avg - b.training_avg,
      multiple: 1,
    },
    render(training_avg) {
      return {
        props: {
          style: {
            background:
              training_avg > 55
                ? "#d9534f"
                : training_avg >= 30 && training_avg <= 55
                ? "#FFC83D"
                : "#31B452",
          },
        },
        children: <div></div>,
      };
    },
  },
];

export function DrillTable({ dataIn }) {
  return <Table dataSource={dataIn} size="small" columns={columns} />;
}
